//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import Dropdown from "@/global/components/Dropdown.vue";
import Guidelines from "./components/GuidelineResults.vue";

export default {
  name: "FilingGuidelines",
  components: {
    Dropdown,
    Guidelines
  },
  data: function () {
    return {
      selectedDomicile: null,
      selectedProfitType: null,
      selectedEntityType: null,
      selectedState: null,
    };
  },
  computed: {
    ...mapGetters([
      "config",
      "loading",
      "results",
      "noResults",
      "noResultsMessage",
      "error",
      "errorMessage"
    ]),
    criterias() {
      return [
        {
          placeholder: this.config.statePlaceholder,
          reference: 'selectedState',
          options: this.config.stateOptions
        },
        {
          placeholder: this.config.domicileTypePlaceholder,
          reference: 'selectedDomicile',
          options: this.config.domicileTypeOptions
        },
        {
          placeholder: this.config.profitTypePlaceholder,
          reference: 'selectedProfitType',
          options: this.config.profitTypeOptions
        },
        {
          placeholder: this.config.entityTypePlaceholder,
          reference: 'selectedEntityType',
          options: this.config.entityTypeOptions
        }
      ]
    },
    canSubmit() {
      return this.selectedDomicile && this.selectedProfitType && this.selectedEntityType && this.selectedState;
    },
    hasResults() {
      return this.canSubmit && this.results;
    }
  },
  methods: {
    ...mapActions(["loadConfig", "getResults", "clearResults"]),
    clearCriteria(reference) {
      this[reference] = null;
      this.clearResults();
    },
    selectCriteria([reference, val]) {
      this[reference] = val;
      if (this.canSubmit) this.submit();
    },
    submit() {
      this.getResults({
        url: this.$root.apiSearch,
        payload: {
          stateId: this.selectedState.id,
          profitType: this.selectedProfitType.id,
          entityType: this.selectedEntityType.id,
          domicileType: this.selectedDomicile.id,
        }
      });
    }
  },
  async created() {
    await this.loadConfig({
      url: this.$root.apiConfig,
      nodeAlias: this.$root.nodeAlias,
      error: this.$root.error,
      noResultsMessage: this.$root.apiNoResultsMessage,
    });
  }
};
